import React from 'react'
import { useState, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import { TiEdit } from "react-icons/ti";
import { Update_Level } from '../../../actions/curriculums/levels';
import { useDispatch, useSelector } from 'react-redux';
import { HomePage } from '../../../translations/trans';
const ModalEdit = ({ item, setMessage }) => {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const name = useRef(item.name);
    const dispatch = useDispatch();

    const onUpdate = async () => {
        try {
            const res = await dispatch(Update_Level({ _id: item._id, name: name.current.value }));
            if (res.data.case) {
                setMessage(res.data.message);
            }
            else {
                setMessage(res.data.message);

            }
            handleClose()
        }
        catch (err) {
            console.log(err);
            setMessage("Supmit function err", err.message);
            handleClose();
        }
    }

    const { lang, dir } = useSelector(({ language }) => {
        return { lang: language.lang, dir: language.dir };
    });

    return (
        <div>

            <TiEdit
                onClick={handleShow}
                size='25px'  />

            <Modal show={show} onHide={handleClose} centered dir={dir}>
                <Modal.Header closeButton>
                    <Modal.Title>{HomePage.editLevel[lang]}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <label className='mb-2'>{HomePage.editLevelDetails[lang]}</label>
                        <input
                            type="text"
                            id="nameLevel"
                            className='form-control'
                            ref={name}
                        />
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={onUpdate}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ModalEdit
